import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
const Enquiryloader = () => {

  return (
    <>
      <div>
        <div className="account-created-pop">
          <h3>Getting your results</h3>
          <p>Finding the best local Electricians for your requirements</p>
          <Row>
            <Col lg={8} className="mx-auto">
              <div className="pop-loader">
                <img src={require("../../assets/images/loader-spinner.png")} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Enquiryloader;
